/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClassRequirement } from './ClassRequirement';
import {
    ClassRequirementFromJSON,
    ClassRequirementFromJSONTyped,
    ClassRequirementToJSON,
} from './ClassRequirement';

/**
 * 
 * @export
 * @interface PaginatedClassRequirementList
 */
export interface PaginatedClassRequirementList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedClassRequirementList
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedClassRequirementList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedClassRequirementList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ClassRequirement>}
     * @memberof PaginatedClassRequirementList
     */
    results?: Array<ClassRequirement>;
}

/**
 * Check if a given object implements the PaginatedClassRequirementList interface.
 */
export function instanceOfPaginatedClassRequirementList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaginatedClassRequirementListFromJSON(json: any): PaginatedClassRequirementList {
    return PaginatedClassRequirementListFromJSONTyped(json, false);
}

export function PaginatedClassRequirementListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedClassRequirementList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ClassRequirementFromJSON)),
    };
}

export function PaginatedClassRequirementListToJSON(value?: PaginatedClassRequirementList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ClassRequirementToJSON)),
    };
}

